import { ReactNode } from 'react'

interface BadgeProps {
  children: ReactNode
  variant?: 'default' | 'dark'
}

export default function Badge({ children, variant = 'default' }: BadgeProps) {
  const classes = variant === 'default'
    ? "inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full bg-[rgba(255,255,255,0.12)] font-semibold text-[0.85rem] uppercase tracking-[0.12em]"
    : "inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full bg-[rgba(27,33,54,0.1)] text-ink font-semibold text-[0.85rem] uppercase tracking-[0.12em]"

  return <div className={classes}>{children}</div>
}
